import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-percent-input',
  templateUrl: './percent-input.component.html',
  styleUrls: ['./percent-input.component.scss']
})
export class PercentInputComponent {

  @ViewChild('input')
  inputElement: ElementRef;

  private _percentValue: string;
  public get percentValue(): string {
    return this._percentValue;
  }

  public set percentValue(v: string) {
    const value = parseInt(v, this.min);
    if (value > this.max) {
      this._percentValue = this.max.toString();
    } else if (value < this.min) {
      this._percentValue = this.min.toString();
    } else {
      this._percentValue = v;
    }

    if (v !== this._percentValue) {
      const input = this.inputElement.nativeElement;
      input.value = this._percentValue;
      input.dispatchEvent(new Event('input'));
    }
  }


  @Input() public max = 100;
  @Input() public min = 0;
  @Input() public step = 5;

  @Output() public valueChange = new EventEmitter<number>();

  @Input()
  public get value(): number {
    return parseInt(this.percentValue, this.min);
  }

  public set value(value: number) {
    if (value > this.max) {
      value = this.max;
    }

    if (value < this.min) {
      value = this.min;
    }

    this.percentValue = `${value}%`;
    this.valueChange.next(value);
  }

  constructor() {
  }

  onBlur() {
    this.value = parseInt(this.percentValue, this.min);
  }

  onPlusClick() {
    this.value = Math.min(this.max, this.value + this.step);
  }

  onMinusClick() {
    this.value = Math.max(this.min, this.value - this.step);
  }

}
